export default __webpack_public_path__ + "static/sign-up-69462537a47dd96817f7018595398cb1.jpg";